import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { pdfContainerSx } from './PdfSxs';
import {
  getGradientStops,
  getProgressMode
} from 'src/content/dashboard/AiComponentes/utils/functions';
import { cardsTexts } from 'src/content/dashboard/TextMessages';
import { cardsCss, newCardsCss } from 'src/content/dashboard/DashboardCss';
import { CustomTooltip } from 'src/content/keywordResearch/CustomTooltip';
import { YourMainCompetitorsCss } from 'src/content/dashboard/AiComponentes/utils/AiComponentsCss';
import {
  AiDashboardSx,
  competitorsStyles as localStyles
} from 'src/content/aiVisibility/utils/style';
import LanguageIcon from '@mui/icons-material/Language';

export const PdfAiCards = () => {
  const pdfReportData = useSelector(
    (state: RootState) => state.dashboard.pdfReportData
  );

  let pdfAiMainVisibilityDetails: any =
    useSelector(
      (state: RootState) => state?.siteAudit?.pdfAiMainVisibilityDetails
    ) ?? null;

  if (pdfReportData?.aiVisibilityDetails) {
    pdfAiMainVisibilityDetails = pdfReportData.aiVisibilityDetails;
  }
  const aiProgressValue = Math.round(
    pdfAiMainVisibilityDetails?.mainVisibilityScore || 0
  ); // Replace with your dynamic value
  const aiProgressDiffValue =
    pdfAiMainVisibilityDetails?.mainVisibilityDiff || 0;
  let aiMode = getProgressMode(aiProgressValue);
  const gradientColorValues = getGradientStops(aiProgressValue);
  const { startColor, endColor } = gradientColorValues;
  const progressValue = Math.round(aiProgressValue || 0); // Replace with your dynamic value
  let progressColor = '#E64420';
  if (progressValue <= 50) {
    progressColor = '#E64420'; //red
  } else if (progressValue >= 51 && progressValue <= 65) {
    progressColor = '#ED9D1D'; //orange
  } else if (progressValue >= 66 && progressValue <= 75) {
    progressColor = '#F6E314'; //yellow
  } else if (progressValue >= 76 && progressValue <= 94) {
    progressColor = '#BEDA1E'; //chartreuse
  } else {
    progressColor = '#25D3B1'; //green
  }

  const competitors = pdfAiMainVisibilityDetails?.competitors || [];
  const topics = pdfAiMainVisibilityDetails?.topics || [];

  return (
    <div
      className="mt-6 mb-6"
      style={{
        ...pdfContainerSx?.pdfMainBoxSx,
        ...pdfContainerSx?.commonBoxMarginSx
      }}
    >
      <div
        style={{
          ...pdfContainerSx?.pdfCardsSx,
          //...pdfContainerSx?.footerAlignBoxSx,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {' '}
        <div style={pdfContainerSx?.chipBoxSx}>
          <img
            src="/static/images/icons/score.svg"
            alt="icon"
            style={pdfContainerSx?.iconStyle}
          />
          <p style={pdfContainerSx?.chipTextSx}>{'AI Visibility Score'}</p>
        </div>
        <Box sx={pdfContainerSx?.circleProgressBoxSx}>

          <svg
            viewBox="0 0 36 36"
            width="170"
            height="170"
            xmlns="http://www.w3.org/2000/svg"
            style={{ position: 'absolute', top: 0, left: 0 }}
          >
            <defs>
              <linearGradient
                id="progressGradient"
                gradientUnits="userSpaceOnUse"
                x1="100%"
                y1="100%"
                x2="0%"
                y2="0%"
              >
                <stop offset="0%" stopColor={startColor} />
                <stop offset="100%" stopColor={endColor} />
              </linearGradient>
            </defs>

            {/* Background Circle */}
            <circle
              cx="18"
              cy="18"
              r="15.915"
              fill="transparent"
              stroke="rgba(242, 244, 247, 1)"
              strokeWidth="3"
            />

            {/* Progress Circle */}
            <circle
              cx="18"
              cy="18"
              r="15.915"
              fill="transparent"
              stroke="url(#progressGradient)" // Gradient added here
              strokeWidth="3"
              strokeDasharray="100"
              strokeDashoffset={`${100 - aiProgressValue}`}
              strokeLinecap="round"
              transform="rotate(-90 18 18)"
            />
          </svg>

          <CustomTooltip title={<Box>{''}</Box>} placement="bottom">
            {/* Text Inside the Progress */}
            <Box sx={newCardsCss?.progressTextBoxSx}>
              <Typography sx={newCardsCss?.progressTextSx}>
                <span
                  style={{
                    ...newCardsCss?.progressTextSpanSx,
                    fontWeight: 600
                  }}
                >
                  {aiProgressValue}
                </span>
                {`%`}
              </Typography>
              <Box
                sx={{
                  ...cardsCss?.iconBoxCss,
                  ...pdfContainerSx?.iconBoxMarginCss
                }}
              >
                {aiProgressDiffValue !== null ? (
                  <>
                    {parseFloat(aiProgressDiffValue) == 0 ? (
                      <>
                        <Typography sx={newCardsCss?.noChangesSx}>
                          {aiProgressValue == 0 ? cardsTexts?.notMentioned : ''}
                        </Typography>
                      </>
                    ) : parseFloat(aiProgressDiffValue) < 0 ? (
                      <>
                        <Box sx={newCardsCss?.trendingIconBoxSx}>
                          <img
                            src="/static/images/icons/red_down.svg"
                            alt="icon"
                            style={{
                              ...pdfContainerSx?.commonImgIconStyle,
                              objectFit: 'contain'
                            }}
                          />
                          <Typography
                            sx={{
                              ...cardsCss?.perSx,
                              ...newCardsCss?.perNewSx
                            }}
                          >
                            {`${parseFloat(aiProgressDiffValue)}%`}
                          </Typography>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Box sx={newCardsCss?.trendingIconBoxSx}>
                          <div
                            style={{
                              ...pdfContainerSx?.commonImgIconStyle,
                              height: 'auto'
                            }}
                          >
                            <img
                              src="/static/images/icons/green_up.svg"
                              alt="icon"
                            />
                          </div>
                          <Typography
                            sx={{
                              ...cardsCss?.perSx,
                              ...pdfContainerSx?.perSxFont
                            }}
                          >
                            {`${parseFloat(aiProgressDiffValue)}%`}
                          </Typography>
                        </Box>
                      </>
                    )}{' '}
                  </>
                ) : (
                  <></>
                )}
              </Box>
            </Box>
          </CustomTooltip>
        </Box>
      </div>

      <div
        style={{
          ...pdfContainerSx?.pdfCardsSx,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <p style={pdfContainerSx?.cardTitleStyles}>
            {'Your Main Competitors'}
          </p>
          <Box>
            {/* Direct Table without TableContainer */}
            {competitors &&
            Array.isArray(competitors) &&
            competitors?.length > 0 ? (
              <Table sx={newCardsCss?.tableSx} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={cardsCss?.tableHeadSx}>
                      <Typography
                        sx={{
                          ...cardsCss?.tHeadTextSx,
                          ...cardsCss?.tHeadAlignment,
                          ...newCardsCss?.pageTypoSx,
                          fontSize: '16px',
                          color: '#686685'
                        }}
                      >
                        {'Brand'}
                      </Typography>
                    </TableCell>
                    <TableCell align="right" sx={cardsCss?.tableHeadSx}>
                      <Typography
                        sx={{
                          ...cardsCss?.tHeadTextSx,
                          ...cardsCss?.tHeadAlignment,
                          ...newCardsCss?.pageTypoSx,
                          textAlign: 'right',
                          fontSize: '16px',
                          color: '#686685'
                        }}
                      >
                        {'Visibility Score'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {competitors?.map((row, index) => (
                    <TableRow key={index} sx={newCardsCss?.tableRowSx}>
                      {/* Adjust the height as needed */}
                      <TableCell sx={cardsCss?.tableCellPage} padding="normal">
                        <Box sx={YourMainCompetitorsCss?.siteIconBox}>
                          {/* Rank (#1, #2, etc.) */}
                          <Typography sx={localStyles.numText(index)}>
                            {`#${index + 1}`}
                          </Typography>
                          <LanguageIcon sx={AiDashboardSx?.languageIconSx} />
                          <Typography
                            sx={{
                              ...cardsCss?.tCellText,
                              ...newCardsCss?.rowPageSx,
                              ...localStyles?.brandName(index)
                            }}
                          >
                            {row?.name || '-'}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          ...cardsCss?.tableCellTraffic
                        }}
                        align="right"
                        padding="normal"
                      >
                        <Typography
                          sx={localStyles.scoreText(index)}
                          color={index === 0 ? 'primary' : 'text.primary'}
                        >
                          {row?.visibilityScore
                            ? `${row?.visibilityScore}%`
                            : '0%'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <>
                <Box sx={cardsCss?.dashBox}>
                  <Typography sx={cardsCss?.dashSx}>{'---'}</Typography>
                </Box>
              </>
            )}
          </Box>
        </div>
      </div>
      <div
        style={{
          ...pdfContainerSx?.pdfCardsSx,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <p style={pdfContainerSx?.cardTitleStyles}>{'Topic Visibility'}</p>
          <Box>
            {topics && Array.isArray(topics) && topics?.length > 0 ? (
              <Box sx={{ marginTop: '16px' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '12px'
                  }}
                >
                  <Typography
                    sx={{
                      ...pdfContainerSx.tableHeadText,
                      color: '#686685',
                      fontSize: '14px'
                    }}
                  >
                    {'Topics'}
                  </Typography>
                  <Typography
                    sx={{
                      ...pdfContainerSx.tableHeadText,
                      color: '#686685',
                      fontSize: '14px'
                    }}
                  >
                    {'Avg Topic Visibility'}
                  </Typography>
                </Box>
                {topics?.map((row, index) => (
                  <div
                    key={index}
                    style={{
                      ...pdfContainerSx.topicRowSx,
                      borderTop:
                        index == 0 ? '1px solid rgba(224, 224, 224, 1)' : 'none'
                    }}
                  >
                    <Typography sx={pdfContainerSx.topicTextSx}>
                      {row?.name || '-'}
                    </Typography>
                    <Typography sx={pdfContainerSx.topicChipTextSx}>
                      {row?.avgVisibility ? `${row?.avgVisibility}%` : '0%'}
                    </Typography>
                  </div>
                ))}
              </Box>
            ) : (
              <>
                <Box sx={cardsCss?.dashBox}>
                  <Typography sx={cardsCss?.dashSx}>{'---'}</Typography>
                </Box>
              </>
            )}
          </Box>
        </div>
      </div>
    </div>
  );
};
